module.exports = __webpack_public_path__ + "static/media/issuance.19b97196.svg";